import { IActions } from "..";
import { options } from "../../lib/options";
import actionKonekConsents from "./action-konek-consents";
import actionNormalizeResponse from "./action-normalize-response";
import actionTokenize from "./action-tokenize";
import actionValidateData from "./action-validate-data";
import actionQueryInstallmentPlans from './action-query-installment-plans';
import actionQueryCurrencyConversion from './action-query-currency-conversion';
import getAssetBaseUrl from "./get-asset-base-url";
import getEnv from "./get-env";
import getQRCodePaymentMethods from "./get-apm-payment-methods";
import { Environments } from "../../../common/enums";
import { INSTALLMENTS_KEY } from "../../lib/installments/contracts/constants";

export const supports = {
  apm: {
    applePay: true,
    clickToPay: true,
    googlePay: true,
  },
  binCheck: {
    hsaFsa: false,
    surcharge: false,
  },
  consumerAuthentication: false,
  tokenization: {
    cardNotPresent: true,
    cardPresent: true,
    eCheck: false,
    gift: false,
  },
};

const domains:any = {
  production: "https://apis.globalpay.com",
  qa: "https://apis-qa.globalpay.com",
  sandbox: "https://apis.sandbox.globalpay.com",
};

const euDomains: any = {
  production: "https://apis.eu.globalpay.com",
  qa: "https://apis.qa.eu.globalpay.com",
  sandbox: "https://apis.sandbox.eu.globalpay.com",
}

/**
 * Validates if the provided service URL matches the domain pattern *.globalpay.com.
 *
 * @param serviceUrl - The URL to be validated.
 */
function validateServiceUrl(serviceUrl: string): boolean {
  // Define the regex pattern to match the domain *.globalpay.com
  const pattern = /^https:\/\/([a-zA-Z0-9-]+\.)*globalpay\.com(\/.*)?$/;

  return pattern.test(serviceUrl);
}

function createResidencyBasedUrl(): string {
  // let domain = prod ? domains.production : domains.sandbox;
  const environment: any = options.env === Environments.Local ? Environments.Sandbox : options.env;
  if (options.dataResidency && options.dataResidency?.toLowerCase() === "eu") {
    return euDomains[environment];
  }
  return domains[environment];
}

export const urls = {
  assetBaseUrl: getAssetBaseUrl,
  tokenization: (prod: boolean) => {
    // let domain = prod ? domains.production : domains.sandbox;
    // const environment = options.env === 'local' ? 'sandbox' : options.env;
    // if (options.env === "qa") {
    //   domain = domains.qa;
    // }

    let domain:any = createResidencyBasedUrl();

    if (options.serviceURL && validateServiceUrl(options.serviceURL)) {
      domain = options.serviceURL;
    }

    let endpoint = "payment-methods";

    if (options.merchantId) {
      endpoint = (options.merchantManagementAccountId ? `accounts/${options.merchantManagementAccountId}/`:'') +`merchants/${options.merchantId}/${endpoint}`;
    }

    return `${domain}/ucp/${endpoint}`;
  },
  queryInstallmentPlans: (prod: boolean) => {
    // let domain = prod ? domains.production : domains.sandbox;
    let domain:any = createResidencyBasedUrl();
    let endpoint = INSTALLMENTS_KEY;
    // if (options.env && (options.env === "qa")) {
    //   domain = domains.qa;
    // }

    if (options.serviceURL) {
      domain = options.serviceURL;
    }

    if( options.merchantId) {
      endpoint = (options.merchantManagementAccountId ? `accounts/${options.merchantManagementAccountId}/`:'') +`merchants/${options.merchantId}/${endpoint}`;
    }

    return `${domain}/ucp/${endpoint}`;
  },
  queryCurrencyConversionUrl: () => {
    // let domain = domains.qa;

    // switch(options.env) {
    //   case Environments.Local:
    //   case Environments.Sandbox:
    //     domain = domains.sandbox;
    //     break;
    //   case Environments.Production:
    //     domain = domains.production;
    //     break;
    // }

    let domain:any = createResidencyBasedUrl();

    if (options.serviceURL) {
      domain = options.serviceURL;
    }

    return `${domain}/ucp/currency-conversions`;
  },
  getQRCodePaymentMethodsUrl: () => {
    // let domain = domains.qa;

    // switch(options.env) {
    //   case Environments.Local:
    //   case Environments.Sandbox:
    //     domain = domains.sandbox;
    //     break;
    //   case Environments.Production:
    //     domain = domains.production;
    //     break;
    // }

    let domain:any = createResidencyBasedUrl();

    if (options.serviceURL) {
      domain = options.serviceURL;
    }

    let endpoint = `accounts/${options.account}`;
    if (options.merchantId) {
      endpoint = `merchants/${options.merchantId}/${endpoint}`;
    }

    return `${domain}/ucp/${endpoint}`;
  },

  getInteracKonekUrl: ()=>{
    const domain : string = createResidencyBasedUrl();
    const endpoint:string = `consents`;

    return `${domain}/ucp/${endpoint}`;
  }
};

export const actions: IActions = {
  normalizeResponse: actionNormalizeResponse,
  tokenize: actionTokenize,
  validateData: actionValidateData,
  queryInstallmentPlans: actionQueryInstallmentPlans,
  queryCurrencyConversion: actionQueryCurrencyConversion,
  getQRCodePaymentMethods,
  getInteracKonek: actionKonekConsents,
};

export const requiredSettings = ["accessToken"];

export { getEnv };
